// Exemplo de importação de imagens
import ac015Img from "../assets/images/products/acessorios/ac015-03.jpg";
import ac005Img from "../assets/images/products/acessorios/ac005-06.jpg";
import ac004Img from "../assets/images/products/acessorios/ac004-14.jpg";
import ac003Img from "../assets/images/products/acessorios/ac003-12.jpg";
// import elementoImg from "../assets/images/products/acessorios/elemento-conexao.jpg";

import antenasScImg from "../assets/images/products/antenas_rfs/Antenas_sc.jpg"
import antenasSbImg from "../assets/images/products/antenas_rfs/Antenas_Sb.jpg"
import antenasDaImg from "../assets/images/products/antenas_rfs/Antenas_DA.jpg"

//cabos protocolo
import profibus from "../assets/images/products/cabos/protocolo/cabo-profibus.jpg"
import Fieldbus from "../assets/images/products/cabos/protocolo/fieldbus.jpg"
import device from "../assets/images/products/cabos/protocolo/device.jpg"


import guiadeonda from "../assets/images/products/cabos/coaxial/Cabo-Coaxial-Guia-De-Onda.jpg"
import hca from "../assets/images/products/cabos/coaxial/Cabo-HCA.jpg"
import rgc from "../assets/images/products/cabos/coaxial/Coaxial-RGC.jpg"
import rf from "../assets/images/products/cabos/coaxial/Cabo-Coaxial-RF.jpg"
import radiaflex from "../assets/images/products/cabos/coaxial/Cabo-Dados-Radiaflex.jpg"

 // cabos opticos
import antiroedor from "../assets/images/products/cabos/opticos/Anti-roedor.png"
import autosustentavel from "../assets/images/products/cabos/opticos/cabo-auto-sustentavel.jpg"
import drop from "../assets/images/products/cabos/opticos/Cabo-DROP-Fig8.png"
import interno_externo from "../assets/images/products/cabos/opticos/interno_externo.png"
import UT from "../assets/images/products/cabos/opticos/tubo-unico.jpg"

// cabo manga
import cabomanga from "../assets/images/products/cabos/manga/cabos-manga.png"
import flat from "../assets/images/products/cabos/flat/cabo-flat.png"
import usomovel from "../assets/images/products/cabos/usomovel/cabo-movel.jpg"

//coaxiais
import coaxiais from "../assets/images/products/cabos/coxial.png"

//antenas

import antenas_acessorios from "../assets/images/products/antenas_rfs/Antenas-Acessorios.jpg"
import antenas_microondas from "../assets/images/products/antenas_rfs/Antenas-Microondas.jpeg"


//temperatura
import compensacao from "../assets/images/products/cabos/temperatura/cabo-de-compensacao.jpg"
import silicone from "../assets/images/products/cabos/temperatura/cabo-silicone.png"
import epr from "../assets/images/products/cabos/temperatura/cabo-epr.png"

//rede
import utp from "../assets/images/products/cabos/rede/utp.png"
import stp from "../assets/images/products/cabos/rede/stp.png"
import ftp from "../assets/images/products/cabos/rede/ftp.png"
import fig8 from "../assets/images/products/cabos/rede/FIG8-CAT5.png"

//energia
import radio from "../assets/images/products/cabos/energia/plast-radio.jpg"
import solido from "../assets/images/products/cabos/energia/fio-solido.jpg"
import paralelo from "../assets/images/products/cabos/energia/cordao-paralelo.jpg"
import cobrenu from "../assets/images/products/cabos/energia/Cabo-de-Cobre-Nu.png"
import solda from "../assets/images/products/cabos/energia/solda.png"
import pp from "../assets/images/products/cabos/energia/CABO-PP.png"
import flex from "../assets/images/products/cabos/energia/CABO-FLEX.png"

//dados
import cabos_instrumentacao from "../assets/images/products/cabos/dados/cabos_instrumentacao.jpg"
import controle from "../assets/images/products/cabos/dados/cabo-de-controle.jpg"
import afs from "../assets/images/products/cabos/dados/afs.png"
import afd from "../assets/images/products/cabos/dados/afd.png"
import cabo_af from "../assets/images/products/cabos/dados/cabo-af.jpg"
import incendio from "../assets/images/products/cabos/dados/Cabo-de-incendio-2-350x210.jpg"



import poliesterTransparenteImg from "../assets/images/products/poliester/poliester-transparente.jpg"
import poliesterCristalImg from "../assets/images/products/poliester/poliester-cristal.jpg"
import poliesterMetalizadoImg from "../assets/images/products/poliester/poliester-metalizado.jpg"
import poliesterLeitosoImg from "../assets/images/products/poliester/poliester-leitoso.jpg"


import poliesterBarreira from "../assets/images/products/poliester/transparente/barreira.png"
import poliesterElevado from "../assets/images/products/poliester/transparente/antiestatico.jpg"
import poliesterAltaBarreira from "../assets/images/products/poliester/metalizado/alta-barreira.jpg"
import poliesterSelavel from "../assets/images/products/poliester/metalizado/matalizado-e-selavel-350x210.jpg"
import poliesterTransferivel from "../assets/images/products/poliester/metalizado/metalizado-transferivel-350x210.png"
import poliesterJanela from "../assets/images/products/poliester/metalizado/Filme-de-Poliester-Metalizado-com-Janela-350x210.jpg"


import poliesterantifog from "../assets/images/products/poliester/destacaveis/selavel_Antifog-350x210.jpg"
import poliesterDestacavel from "../assets/images/products/poliester/destacaveis/Selavel-e-destacavel-350x210.jpg"
import poliesterMatte from "../assets/images/products/poliester/destacaveis/matte-350x210.jpg"

import poliesterBranco from "../assets/images/products/poliester/filmes de poliester/Poliester-Branco-Opaco-350x210.jpg"
import poliesterAluminio from "../assets/images/products/poliester/filmes de poliester/poliester_alimunio-350x210.jpg"
import poliesterReciclavel from "../assets/images/products/poliester/filmes de poliester/reciclavel-350x210.jpg"

import termolaminacaoDourado from "../assets/images/products/termolaminacao/termolaminacao-dourado.jpg"
import termolaminacaoPrata from "../assets/images/products/termolaminacao/termolaminacao-prata.jpg"
import termolaminacaoBopp from "../assets/images/products/termolaminacao/filmes-bopp.jpg"

import fita27 from "../assets/images/products/fitas_adesivas/fita27.jpg"
import fita1350 from "../assets/images/products/fitas_adesivas/fita1350.jpg"
import fita56 from "../assets/images/products/fitas_adesivas/fita56.jpg"
import fita69 from "../assets/images/products/fitas_adesivas/fita69.jpg"
import fita_cobre from "../assets/images/products/fitas_adesivas/fita_cobre.jpg"
import fita_rayon from "../assets/images/products/fitas_adesivas/acetato_rayon.jpg"
import fita_vidro from "../assets/images/products/fitas_adesivas/fibra_vidro.jpg"
import fita_kapton from "../assets/images/products/fitas_adesivas/KAPTON.jpg"
import fita_mika from "../assets/images/products/fitas_adesivas/MIKA.jpg"

import fita35Img from "../assets/images/products/fitas_isolantes/fita35.jpg"
import fitaImperialImg from "../assets/images/products/fitas_isolantes/fita-imperial.jpg"
import fitaHighlandImg from "../assets/images/products/fitas_isolantes/fita-highland.jpg"
import fita33Img from "../assets/images/products/fitas_isolantes/fita33.jpg"
import fita23Img from "../assets/images/products/fitas_isolantes/fita23.jpg"

import cadarcoAlgodao from "../assets/images/products/isolantes/cadarcos/cadarcos-algodao-350x210.png"
import cadarcoVidro from "../assets/images/products/isolantes/cadarcos/cadarco-fibra-de-vidro-350x210.jpg"
import cadarcoPoliester from "../assets/images/products/isolantes/cadarcos/cadarco-poliester-350x210.jpg"
import celeron from "../assets/images/products/isolantes/chapas/celeron-350x210.jpg"
import fenolite from "../assets/images/products/isolantes/chapas/fenolite-1-350x210.jpg"
import tve from "../assets/images/products/isolantes/chapas/tve-1-350x210.jpg"


import Fiberglass from "../assets/images/products/isolantes/espaguetes/Fiberglass-350x210.png"
import Flexnor from "../assets/images/products/isolantes/espaguetes/Flexnor-350x210.jpg"
import Flexpoli from "../assets/images/products/isolantes/espaguetes/Flexpoli-350x210.png"
import TCN20 from "../assets/images/products/isolantes/espaguetes/TCN20-350x210.png"
import pvc from "../assets/images/products/isolantes/espaguetes/pvc-350x210.png"
import espaguete_silicone from "../assets/images/products/isolantes/espaguetes/silicone-250x210.png"
import retratil from "../assets/images/products/isolantes/espaguetes/termo-retratil-311x210.png"

import cequinImg from "../assets/images/products/papeis_isolantes/cequin.jpg"
import fibraImg from "../assets/images/products/papeis_isolantes/Fibra_industrial_vermelha.png"
import guarnitalImg from "../assets/images/products/papeis_isolantes/Guarnital.jpg"
import kraftImg from "../assets/images/products/papeis_isolantes/kraft.jpg"
import NomexImg from "../assets/images/products/papeis_isolantes/Nomex.jpg"
import PresspahnImg from "../assets/images/products/papeis_isolantes/Presspahn.jpg"
import TimboImg from "../assets/images/products/papeis_isolantes/timbo.jpg"

import radioCeragonImg from "../assets/images/products/radio/radio-ceragon.jpg"
import radiofiberAirImg from "../assets/images/products/radio/The-FibeAir-IP-20C-350x210.jpg"
import radiofiber20gAirImg from "../assets/images/products/radio/fibeair.jpg"


import eia from "../assets/images/products/acessorios/ACESSORIOS.jpg"
import abracadeira from "../assets/images/products/acessorios/CONECTOR.jpg"

import noimage from "../assets/images/products/default/no_image.jpg"

// Exemplo de dados de produtos com imagens associadas
export const sampleProducts = {
    acessorios: [
      { name: "CONECTOR - BNC", image: noimage, type: "Conectores" },
      { name: "CONECTOR MINI DIN 4.3-10", image: noimage, type: "Conectores" },
      { name: "CONECTOR - DIN 7/16", image: noimage, type: "Conectores" },
      { name: "CONECTOR - EIA", image: eia, type: "Conectores" },
      { name: "CONECTOR - F", image: noimage, type: "Conectores" },
      { name: "CONECTOR - IEC", image: noimage, type: "Conectores" },
      { name: "CONECTOR - N", image: noimage, type: "Conectores" },
      { name: "CONECTOR - RJ45", image: noimage, type: "Conectores" },
      { name: "CONECTOR - TNC", image: noimage, type: "Conectores" },
      { name: "CONECTOR - UHF", image: noimage, type: "Conectores" },
      { name: "ABRAÇADEIRA", image: abracadeira, type: "Acessórios" },
      { name: "ADAPTADOR", image: noimage, type: "Acessórios" },
      { name: "ATERRAMENTO", image: noimage, type: "Acessórios" },
      { name: "TWISTFLEX", image: noimage, type: "Acessórios" },
      { name: "DESIDRATADOR", image: noimage, type: "Acessórios" },
      { name: "FERRAMENTAS   DE PREPARAÇÃO / CONECTORIZAÇÃO", image: noimage, type: "Acessórios" },
      { name: "JUMPER", image: noimage, type: "Acessórios" },
    ],
    antenas_rfs: [
      { name: "Acessorios", image: antenas_acessorios, type: "Acessórios" },
      { name: "POLARIZAÇÃO SIMPLES", image: noimage, type: "Microondas" },
      { name: "POLARIZAÇÃO DUPLA", image: noimage, type: "Microondas" },
    ],
    cabos: [
      { name: "Cabo AF", image: cabo_af, type: "Dados" },
      { name: "Cabo AFD", image: afd, type: "Dados" },
      { name: "Cabo AFS", image: afs, type: "Dados" },
      { name: "Cabos de Controle", image: controle, type: "Dados" },
      { name: "Cabos de Instrumentação", image: cabos_instrumentacao, type: "Dados" },
      { name: "Cabos de Incêndio", image: incendio, type: "Dados" },
      { name: "Cabos Manga", image: cabomanga, type: "Dados" },
      { name: "Cabo de Uso Móvel", image: usomovel, type: "Dados" },
      { name: "Cabos Flat", image: flat, type: "Dados" },
      { name: "CABOS DATA CABLE", image: noimage, type: "Dados" },
      { name: "Cabo de Rede - Patchcord", image: stp, type: "Dados" },
      { name: "Cabo de Rede - Par Trançado", image: stp, type: "Dados" },
      { name: "Cabos Protocolo", image: profibus, type: "Dados" },
      // { name: "Profibus", image: profibus, type: "Dados" },
      // { name: "Fieldbus", image: Fieldbus, type: "Dados" },
      // { name: "Device", image: device, type: "Dados" },
  
      { name: "Cabo Flex", image: flex, type: "Energia" },
      { name: "Cabo PP", image: pp, type: "Energia" },
      { name: "Cabo Solda", image: solda, type: "Energia" },
      { name: "Cabo de Cobre Nu", image: cobrenu, type: "Energia" },
      { name: "Cordão Paralelo", image: paralelo, type: "Energia" },
      { name: "Cordão Torcido", image: noimage, type: "Energia" },
      { name: "Fio Sólido", image: solido, type: "Energia" },
      { name: "Plast Rádio", image: radio, type: "Energia" },
  
      { name: "Cabos EPR", image: epr, type: "Temperatura" },
      { name: "Cabos de Silicone", image: silicone, type: "Temperatura" },
      { name: "Cabos de Compensação", image: compensacao, type: "Temperatura" },
  
      { name: "LCF", image: noimage, type: "Coaxial" },
      { name: "SCF", image: noimage, type: "Coaxial" },
      { name: "HCA", image: hca, type: "Coaxial" },
      { name: "GUIA DE ONDA ELÍPTICO", image: guiadeonda, type: "Coaxial" },
      { name: "RF", image: rf, type: "Coaxial" },
      { name: "RGC", image: rgc, type: "Coaxial" },
      { name: "Radiaflex", image: radiaflex, type: "Coaxial" },
      
      { name: "Fibra Óptica - MM", image: antiroedor, type: "Óptico" },
      { name: "Fibra Óptica - SM", image: autosustentavel, type: "Óptico" },
  
      { name: "Betacavi", image: noimage, type: "Betacavi" },
      { name: "Conector", image: noimage, type: "Betacavi" },
      { name: "Ferramentas de preparação e conectorização", image: noimage, type: "Betacavi" },

      
      { name: "Cabos Belden", image: noimage, type: "Belden" },
  
      // { name: "Cabos Anti-roedor", image: antiroedor, type: "Óptico" },
      // { name: "Cabo Auto-sustentável", image: autosustentavel, type: "Óptico" },
      // { name: "Cabo DROP Fig. 8", image: drop, type: "Óptico" },
      // { name: "Cabo Interno ou Externo (EO)", image: interno_externo, type: "Óptico" },
      // { name: "Cabo Tubo Único (UT)", image: UT, type: "Óptico" },
  
    ],
    filmes_poliester: [
      { name: "Filmes de Poliéster Transparente", image: poliesterTransparenteImg, type: "Filme Transparente" },
      { name: "Filme de Poliéster com Barreira PVDC", image: poliesterBarreira, type: "Filme Transparente" },
      { name: "Filme de Poliéster de Elevado Atrito", image: poliesterElevado, type: "Filme Transparente" },
  
      { name: "Filmes de Poliéster Cristal", image: poliesterCristalImg, type: "Filme Cristal" },
  
      { name: "Filmes de Poliéster Metalizado", image: poliesterMetalizadoImg, type: "Filme Metalizado" },
      { name: "Filme de Poliéster Metalizado de Alta Barreira", image: poliesterAltaBarreira, type: "Filme Metalizado" },
      { name: "Filme de Poliéster Metalizado e Selável", image: poliesterSelavel, type: "Filme Metalizado" },
      { name: "Filme de Poliéster Metalizado Transferível", image: poliesterTransferivel, type: "Filme Metalizado" },
      { name: "Filme de Poliéster Metalizado com Janela", image: poliesterJanela, type: "Filme Metalizado" },
  
      { name: "Filmes de Poliéster Leitoso", image: poliesterLeitosoImg, type: "Filme Leitoso" },
  
      { name: "Filme de Poliéster Selável com Antifog", image: poliesterantifog, type: "Filme Selável" },
      { name: "Filme de Poliéster Selável e Destacável", image: poliesterDestacavel, type: "Filme Selável" },
  
      { name: "Fitas de Poliéster + Alumínio – Blindagem de Cabos", image: poliesterAluminio, type: "Fita de Poliéster" },
      { name: "Filme de Poliéster Reciclado", image: poliesterReciclavel, type: "Filme Reciclado" },
      { name: "Poliéster Branco Opaco", image: poliesterBranco, type: "Filme Reciclado" },
      { name: "Filme de Poliéster Matte", image: poliesterMatte, type: "Filme Matte" },
    ],
    termolaminacao: [
      { name: "Poliéster Termolaminação Dourado", image: termolaminacaoDourado, type: "Termolaminação Dourado" },
      { name: "Poliéster Termolaminação Prata", image: termolaminacaoPrata, type: "Termolaminação Prata" },
      { name: "FILMES BOPP FOSCO e BRILHO", image: termolaminacaoBopp, type: "Filmes BOPP" }
    ],
    fitas_adesivas: [
      { name: "Fita 27", image: fita27, type: "Fita Adesiva" },
      { name: "Fita 1350", image: fita1350, type: "Fita Adesiva" },
      { name: "Fita 56", image: fita56, type: "Fita Adesiva" },
      { name: "Fita 69", image: fita69, type: "Fita Adesiva" },
      { name: "Fita de Cobre", image: fita_cobre, type: "Fita de Cobre" },
      { name: "Fita Acetato de Rayon", image: fita_rayon, type: "Fita Rayon" },
      { name: "Fibra de Vidro", image: fita_vidro, type: "Fita Fibra de Vidro" },
      { name: "Fita Kapton", image: fita_kapton, type: "Fita Kapton" },
      { name: "Fita de Mica", image: fita_mika, type: "Fita de Mica" },
    ],
    fitas_isolantes: [
      { name: "Fita 35+", image: fita35Img, type: "Fita Isolante" },
      { name: "Fita Imperial", image: fitaImperialImg, type: "Fita Isolante" },
      { name: "Fita Highland", image: fitaHighlandImg, type: "Fita Isolante" },
      { name: "Fita 33+", image: fita33Img, type: "Fita Isolante" },
      { name: "Fita 23 BR", image: fita23Img, type: "Fita Isolante" }
    ],
    isolantes: [
      { name: "Cadarço de Algodão", image: cadarcoAlgodao, type: "Cadarço Isolante" },
      { name: "Cadarço de Fibra de Vidro", image: cadarcoVidro, type: "Cadarço Isolante" },
      { name: "Cadarço de Poliéster", image: cadarcoPoliester, type: "Cadarço Isolante" },
  
      { name: "Celeron", image: celeron, type: "Chapa Isolante" },
      { name: "Fenolite", image: fenolite, type: "Chapa Isolante" },
      { name: "TVE", image: tve, type: "Chapa Isolante" },
  
      { name: "Fiberglass", image: Fiberglass, type: "Espaguete Isolante" },
      { name: "Flexnor", image: Flexnor, type: "Espaguete Isolante" },
      { name: "Flexpoli", image: Flexpoli, type: "Espaguete Isolante" },
      { name: "PVC", image: pvc, type: "Espaguete Isolante" },
      { name: "Silicone", image: espaguete_silicone , type: "Espaguete Isolante" },
      { name: "TCN20", image: TCN20, type: "Espaguete Isolante" },
      { name: "Termo-retrátil", image: retratil, type: "Espaguete Isolante" }
    ],
    papeis_isolantes: [
      { name: "Cequin", image: cequinImg, type: "Papel Isolante" },
      { name: "Fibra Industrial Vermelha", image: fibraImg, type: "Papel Isolante" },
      { name: "Guarnital", image: guarnitalImg, type: "Papel Isolante" },
      { name: "Kraft", image: kraftImg, type: "Papel Isolante" },
      { name: "Nomex", image: NomexImg, type: "Papel Isolante" },
      { name: "Presspahn", image: PresspahnImg, type: "Papel Isolante" },
      { name: "Timbó", image: TimboImg, type: "Papel Isolante" },
    ],
    radio: [
      { name: "The FibeAir IP-20C", image: radiofiberAirImg, type: "Radio" },
      { name: "FibeAir IP-20S", image: radioCeragonImg, type: "Radio" },
      { name: "FibeAir IP-20G", image: radiofiber20gAirImg, type: "Radio" },
  
      { name: "Licenças", image: noimage, type: "Licenças" },
      { name: "Acessórios", image: noimage, type: "Acessóros" },
    ]
  };